import { z } from 'zod';
import {
	dynamicInputSchema,
	entityFormSchema,
	entityXProductsFormSchema,
	filterSchema,
	headerFormSchema,
	heroBannerFormSchema,
	heroBannerItemSchema,
	imageWithTextFormSchema,
	linkNodeSchema,
	miniBannerFormSchema,
	octaneAnnouncementBarFormSchema,
	octaneFooterSchema,
	productContentFormchema,
	productContentItemSchema,
	productFormSchema,
	staticInputFormSchema,
	staticInputSchema,
	superCarouselFormSchema,
	superCarouselItemSchema,
	timerSchema,
	videoBannerFormSchema,
	videoBannerItemSchema,
} from './zod';

export type OctaneHeaderData = z.infer<typeof headerFormSchema>;
export type NavMenuItem = OctaneHeaderData['menubar'][number];
export type LinkNode = z.infer<typeof linkNodeSchema>;
export type DynamicInputData = z.infer<typeof dynamicInputSchema>;
export type StaticInputData = z.infer<typeof staticInputSchema>;
export type StaticInputFormSchema = z.infer<typeof staticInputFormSchema>;

export type EntityData = z.infer<typeof entityFormSchema>;

export type EntityXProductData = z.infer<typeof entityXProductsFormSchema>;

export type ProductsData = z.infer<typeof productFormSchema>;

export type OctaneFooterData = z.infer<typeof octaneFooterSchema>;

export type HeroBannerData = z.infer<typeof heroBannerFormSchema>;
export type VideoBannerData = z.infer<typeof videoBannerFormSchema>;
export type MiniBannerData = z.infer<typeof miniBannerFormSchema>;
export type HeroBannerItem = z.infer<typeof heroBannerItemSchema>;
export type VideoBannerItem = z.infer<typeof videoBannerItemSchema>;
export type ImageWithTextData = z.infer<typeof imageWithTextFormSchema>;
export type TimerSchema = z.infer<typeof timerSchema>;

export type FilterSchema = z.infer<typeof filterSchema>;

export type SuperCarouselData = z.infer<typeof superCarouselFormSchema>;
export type SuperCarouselItem = z.infer<typeof superCarouselItemSchema>;

export type AnnouncementBarData = z.infer<
	typeof octaneAnnouncementBarFormSchema
>;
export type ProductContentSchema = z.infer<typeof productContentItemSchema>;
export type ProductContentData = z.infer<typeof productContentFormchema>;

export const NON_ARRAY_FILTERS = [
	'price.from',
	'price.to',
	'price.upto',
	'sort',
	'period',
];

export const ARRAY_FILTERS_VALUES = [
	'size',
	'brand',
	'discount',
	'node_id',
	'delivery_days',
	'tags',
	'attrs',
] as const;

export type ARRAY_FILTERS_TYPES = (typeof ARRAY_FILTERS_VALUES)[number];

export const enum MimeTypes {
	WEBP = 'image/webp',
	PNG = 'image/png,',
	JPEG = 'image/jpeg',
}

export const enum FileSizes {
	IMAGE_MEDIUM = 1024 * 1024 * 2,
}
